'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { measurePageView } from './oaiq';

// O App Router troca de página no cliente: sem isso o pixel registraria apenas a
// primeira página de cada visita e a performance das campanhas ficaria subestimada.
// O page_viewed da página de entrada sai do próprio snippet de init (ver index.tsx),
// então o pathname inicial é ignorado aqui — senão o evento sairia duplicado.
export default function PageViewTracker() {
	const lastTracked = useRef<string | null>(null);
	const pathname = usePathname();

	useEffect(() => {
		if (!pathname || lastTracked.current === pathname) {
			return;
		}

		const isFirstPath = lastTracked.current === null;
		lastTracked.current = pathname;

		if (isFirstPath) {
			return;
		}

		measurePageView(pathname, document.title);
	}, [pathname]);

	return null;
}
